import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_DANHSACHNHANVIEN } from "actions/DanhSachNhanVien/actionTypes";
import {
  getListDanhSachNhanVienSuccess,
  getListDanhSachNhanVienFailure,
} from "actions/DanhSachNhanVien";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";
import { pushNotification } from "utils/notifications";

function* getListDanhSachNhanVien(action) {
  try {
    const response = yield call(DanhSachNhanVienApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListDanhSachNhanVienSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListDanhSachNhanVienFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListDanhSachNhanVienFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_DANHSACHNHANVIEN, getListDanhSachNhanVien);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
